import React from "react";

interface HeaderReferenceIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const HeaderReferenceIcon: React.FC<HeaderReferenceIconProps> = ({
  width = 11,
  height = 11,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 11"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M6.96477 10.0624C6.36197 10.6959 4.98364 10.7455 3.6089 10.1904V11H1.55583V8.80962C-0.0728283 7.12394 -0.463571 4.69035 0.577096 3.95092L3.1569 6.41918L4.49217 5.50666C4.42944 5.36528 4.39474 5.20979 4.39474 5.04652C4.39474 4.39563 4.94627 3.86795 5.62659 3.86795C6.30694 3.86795 6.85844 4.39563 6.85844 5.04652C6.85844 5.69744 6.30694 6.2251 5.62659 6.2251C5.42047 6.2251 5.22615 6.17666 5.05543 6.09104L4.12148 7.34201L6.96477 10.0624ZM5.66199 1.96427C7.47621 1.96427 8.94693 3.37139 8.94693 5.10714C8.94693 5.74831 8.74623 6.34464 8.4017 6.84175C8.48941 6.53979 8.5363 6.22155 8.5363 5.89284C8.5363 3.94013 6.88176 2.35712 4.84075 2.35712C4.49718 2.35712 4.16458 2.40198 3.84894 2.48592C4.36855 2.15627 4.99184 1.96427 5.66199 1.96427ZM6.23746 0C8.86776 0 11 2.15336 11 4.80969C11 5.79091 10.709 6.7035 10.2095 7.46428C10.3367 7.00216 10.4047 6.51515 10.4047 6.01211C10.4047 3.02375 8.0059 0.601196 5.04684 0.601196C4.54874 0.601196 4.0665 0.669851 3.6089 0.798278C4.36222 0.293824 5.26588 0 6.23746 0Z" />
  </svg>
);
